export default "__VITE_ASSET__DPCrscKS__"